export const generateReactKey = (pre: string) => {
  return `${pre}_${new Date().getTime()}`;
};
